import { render, staticRenderFns } from "./lazy.vue?vue&type=template&id=6608a0d0&scoped=true&"
import script from "./lazy.vue?vue&type=script&lang=js&"
export * from "./lazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608a0d0",
  null
  
)

export default component.exports